import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { createMagazine, toggleToaster } from '@/store/actions'

import styles from './styles.scss'

class MagazineModal extends Component {
  state = {
    title: '',
    description: ''
  }

  closeModal = () => {
    const { handleClose } = this.props
    this.setState({
      title: '',
      description: '',
    })
    handleClose()
  }

  handleCreateMagazine = () => {
    const { translation, createMagazine, toggleToaster } = this.props

    createMagazine(this.state)
    toggleToaster({
      isVisible: true,
      message: translation('general-magazine-create-success'),
      position: 'top-right',
      type: 'success'
    })
    this.setState({
      title: '',
      description: ''
    })
  }

  render() {
    const { title, description } = this.state
    var { show, translation, handleClose } = this.props

    return (
      <section className={'ba-flex ba-jc-center ba-ai-center ' + (show ? styles['ba-modal'] : styles['ba-none'])}>
        <div className={'ba-card ' + styles['ba-modal-card']}>
          <div className="ba-top ba-flex ba-jc-sb">
            <span className="ba-title ba-montserrat-700">
              {translation('magazine-new-magazine')}
            </span>

            <button className='ba-btn ba-btn-close ba-sm ba-rounded'
              onClick={handleClose}>
              <builderall-icon code='64f7' />
            </button>
          </div>

          <div className="ba-content ba-w-100">

            <div className='ba-box-input ba-mg-t-1'>
              <div className='ba-info'>
                <div className='ba-info-left'>
                  <label className='ba-label' for='title'>
                    {translation('magazine-title')}
                  </label>
                </div>
              </div>
              <input type='text' id='title' className='ba-input' maxLength="50"
                placeholder={translation('magazine-create-label-title')}
                value={title}
                onChange={({ target }) => this.setState({ title: target.value })} />
            </div>

            <div className='ba-box-input ba-mg-t-1'>
              <div className='ba-info'>
                <div className='ba-info-left'>
                  <label className='ba-label' for='description'>
                    {translation('magazine-description')}
                  </label>
                </div>
              </div>
              <input type='text' id='description' className='ba-input' maxLength="50"
                placeholder={translation('magazine-create-label-description')}
                value={description}
                onChange={({ target }) => this.setState({ description: target.value })} />
            </div>

            <div className='ba-flex ba-jc-fe ba-mg-t-3'>
              <button className='ba-btn ba-md ba-blue'
                disabled={!this.state.title}
                onClick={this.handleCreateMagazine}>
                <builderall-icon code='2780' />
                {translation('general-create-new')}
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(mapStateToProps, {
  createMagazine,
  toggleToaster
})(MagazineModal)



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineModal/index.js